// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__3Fbb9","loadingShrink":"PageLoading_loadingShrink__2uCHl"};